import React from 'react';
import Layout from 'components/Layout';
import { ImageWithText as LogoImage } from 'components/BigLogo';
import { StyledContent, HeroLandscape, HeroBackground, BlockBackground, CloudsLeft, CloudsRight } from './styles';
import MountainLeft from 'assets/images/mountain-left.png';
import MountainRight from 'assets/images/mountain-right.png';
import MountainEdge from 'assets/images/mountain-edge.png';
import Trees from 'assets/images/2trees.png';
import Tree from 'assets/images/tree.png';
import ManVan from 'assets/images/man-with-a-van.png';
import WomanChair from 'assets/images/woman-in-chair.png';
import Cloud20 from 'assets/images/20-year-cloud.png';
import Sun from 'assets/images/sun.png';
import Image from 'components/Image';
import { graphql, StaticQuery } from 'gatsby';

const Cloud: React.FunctionComponent = () => (
  <StaticQuery
  query={graphql`
  query Cloud {
    wordpress {
      themeSettings {
      themeOptions {
        cloud {
          sourceUrl
        }
      }
    }
    }
  }
  `}
  render={({wordpress}) => {
    if(wordpress?.themeSettings?.themeOptions?.cloud?.sourceUrl){
      return <Image className="Cloud20yrs" sourceUrl={wordpress.themeSettings.themeOptions.cloud.sourceUrl} />
    }
    return <Image className="Cloud20yrs" sourceUrl={Cloud20} />
  }}
   />
);

const FrontpageHero: React.FunctionComponent<any> = ({ children, pageHasAnnouncement }) => (
  <Layout.Section>
    <StyledContent isFirstSection={true} pageHasAnnouncement={pageHasAnnouncement}>
      <Layout.ContentInner>
        <HeroBackground>
          <LogoImage />
          <Cloud />
          <HeroLandscape>
            <Image className="mountain-left" sourceUrl={MountainLeft} />
            <Image className="sun" sourceUrl={Sun} />
            <Image className="mountain-right" sourceUrl={MountainRight} />
            <Image className="edge" sourceUrl={MountainEdge} />
            <Image className="tree" sourceUrl={Tree} />
            <Image className="trees" sourceUrl={Trees} />
          </HeroLandscape>
          <CloudsLeft />
          <CloudsRight />
        </HeroBackground>
        <BlockBackground>
          <Image className="womanChair" sourceUrl={WomanChair} />
          <Image className="manVan" sourceUrl={ManVan} />
          {children}
        </BlockBackground>
      </Layout.ContentInner>
    </StyledContent>
  </Layout.Section>
);

export default FrontpageHero;
